import { Box } from "@mui/material";
import { questionMediaSurface } from "../../components/ui/QuestionSurface/styles";
import { useThemeContext } from "../../globalContext/global-context";
import type { QuestionViewProps } from "../contracts";
import type { EmbedDefinition, EmbedDraft, EmbedEvent } from "./core";
import { parseTrustedIframe } from "./iframe";

type ViewProps = QuestionViewProps<EmbedDefinition, EmbedDraft, EmbedEvent>;

export const EmbedView = ({ definition, display }: ViewProps) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const iframe = parseTrustedIframe(definition.embedCode);
  return (
    <Box
      data-testid="embed-view"
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        ...questionMediaSurface(theme),
      }}
    >
      {iframe && (
        <Box
          component="iframe"
          data-testid="trusted-embed-iframe"
          {...iframe}
          title={
            iframe.title?.trim() ||
            definition.prompt.trim() ||
            theme.copy.labels.embeddedContent
          }
          sx={{
            width: "100%",
            maxWidth: "100%",
            minHeight: display.arrangement === "wide" ? 600 : 300,
            border: 0,
          }}
        />
      )}
    </Box>
  );
};
